export const SERIALIZATION_VERSION = 6;
